import { browserHistory } from 'react-router'
import React, {Component} from 'react'
import TemplateEditForm from "./form/edit.component.jsx"
import SideBar from '../common/layout/sidebar.component.jsx'

class TemplateNew extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            documentType: this.props.match.params.documentType,
        }
    }

    componentDidMount() {
        SideBar.activateMenu('sales-tools')
    }

    render() {
        return (
            <div>
                <TemplateEditForm documentType={this.state.documentType}/>
            </div>
        );
    }
}

export default TemplateNew


// WEBPACK FOOTER //
// ./src/template/new.component.jsx